import './view.scss';
import Splide from '@splidejs/splide';
import { Intersection } from '@splidejs/splide-extension-intersection';

function locationSliderSplide() {
    let locationSliders = document.getElementsByClassName('location-slider__items');
    if (locationSliders.length > 0) {
        let options = {
            gap: 0,
            arrows: true,
            pagination: false,
            type: 'slide',
            perMove: 3,
            autoplay: 'pause',
            intersection: {
                inView: {
                    autoplay: true,
                },
                outView: {
                    autoplay: false,
                },
            },
            fixedWidth: '33.33%',
            speed: 1000,
            breakpoints: {
                390: {
                    fixedWidth: '85%',
                    perMove: 1,
                },
                600: {
                    fixedWidth: '72%',
                    perMove: 1,
                },
                767: {
                    fixedWidth: '66%',
                    perMove: 1,
                },
                992: {
                    fixedWidth: '45%',
                    perMove: 2,
                },
                1200: {
                    fixedWidth: '40%',
                    perMove: 2,
                },
                1400: {
                    fixedWidth: '36%',
                    perMove: 2,
                }
            }
        };

        for (let i = 0; i < locationSliders.length; i++) {
            let splide = new Splide(locationSliders[i], options);

            splide.on('overflow', function (isOverflow) {
                splide.options = {
                    drag: isOverflow
                };
            });

            splide.mount({Intersection});
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    if (document.getElementsByClassName('location-slider').length > 0) {
        locationSliderSplide();
    }
});
